import de from "~/lang/de-DE/location.json";
import en from "~/lang/en-US/location.json";
import es from "~/lang/es-ES/location.json";
import it from "~/lang/it-IT/location.json";
import nl from "~/lang/nl-NL/location.json";

/**
 * The Location wording of every catalogue string that has one, per locale.
 * Keyed exactly like `~/lang`, so it lays straight over it — see
 * `@shared/constants/nomenclature`.
 */
export default {
  "de-DE": de,
  "en-US": en,
  "es-ES": es,
  "it-IT": it,
  "nl-NL": nl,
};
